// GENERATED by scripts/generate-test-localized-slugs.ts — do not hand-edit.
// Plain static data, deliberately no imports: lib/localized-route-slugs.ts
// (which this feeds) is loaded by next.config.ts outside the tsconfig path
// aliases, so nothing it pulls in may be an "@/..." import, an env read, or
// a CMS fetch at module load. Regenerate with: pnpm run generate:test-slugs
export const TEST_LOCALIZED_SLUGS: Record<string, Record<string, string>> = {
  "/tests/brain-volumetry": {
    de: "/tests/gehirnanalyse",
    fr: "/tests/volumetrie-cerebrale",
    nl: "/tests/hersenanalyse",
  },
  "/tests/omega-blood-test": {
    de: "/tests/omega-3-6-bluttest",
    fr: "/tests/bilan-sanguin-omega-3-6",
    nl: "/tests/omega-3-6-bloedtest",
  },
  "/tests/mamma-mri": {
    fr: "/tests/irm-mammaire",
  },
  "/tests/body-composition": {
    de: "/tests/koerperzusammensetzung",
    fr: "/tests/composition-corporelle",
    nl: "/tests/lichaamssamenstelling",
  },
  "/tests/hormone-blood-test-women": {
    de: "/tests/hormon-bluttest-frauen",
    fr: "/tests/bilan-hormonal-sanguin-femmes",
    nl: "/tests/hormoon-bloedtest-vrouwen",
  },
  "/tests/hormone-blood-test-men": {
    de: "/tests/hormon-bluttest-maenner",
    fr: "/tests/bilan-hormonal-sanguin-hommes",
    nl: "/tests/hormoon-bloedtest-mannen",
  },
  "/tests/calcium-score": {
    de: "/tests/kalzium-score",
    fr: "/tests/score-calcique",
    nl: "/tests/calciumscore",
  },
  "/tests/essential-b-vitamins-test": {
    de: "/tests/essentielle-b-vitamine-bluttest",
    fr: "/tests/bilan-sanguin-vitamines-b-essentielles",
    nl: "/tests/essentiele-b-vitamines-test",
  },
  "/tests/full-body-mri": {
    de: "/tests/ganzkoerper-mri",
    fr: "/tests/irm-corps-entier",
    nl: "/tests/holistic-mri",
  },
}

// Per (canonical /tests path, locale), the countries where the English→
// localized 308 is safe (AHD-13374, F1) — see buildTestSlugRedirectCountries
// in scripts/generate-test-localized-slugs.ts. de/nl ONLY — status-
// independent (static LOCALE_COUNTRIES x data/tests.ts availability, never
// publicCountries/*_STATUS/*_ENABLED). fr is deliberately absent: it's
// CH-only and stays unscoped, same as the static fr-only /tests entries.
// Consumed by localizedSlugRedirects() in lib/localized-route-slugs.ts to
// narrow the redirect's :country matcher so it never 308s into a market
// where the test is unavailable. An empty array means "scoped to zero
// countries" (no redirect rule emitted), distinct from a path/locale
// absent from this map entirely (falls back to the unscoped/
// SLUG_COUNTRIES behavior).
export const TEST_SLUG_REDIRECT_COUNTRIES: Record<
  string,
  Record<string, string[]>
> = {
  "/tests/brain-volumetry": {
    de: ["ch"],
    nl: ["nl"],
  },
  "/tests/omega-blood-test": {
    de: ["ch", "de"],
    nl: ["nl"],
  },
  "/tests/body-composition": {
    de: ["ch", "at"],
    nl: ["nl"],
  },
  "/tests/hormone-blood-test-women": {
    de: ["ch", "de"],
    nl: ["nl"],
  },
  "/tests/hormone-blood-test-men": {
    de: ["ch", "de"],
    nl: ["nl"],
  },
  "/tests/calcium-score": {
    de: ["ch"],
    nl: ["nl"],
  },
  "/tests/essential-b-vitamins-test": {
    de: ["ch", "de"],
    nl: ["nl"],
  },
  "/tests/full-body-mri": {
    de: ["ch", "at"],
    nl: ["nl"],
  },
}
